import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class CostCentreReferenceService extends BaseReferenceService {
  constructor() {
    super('CostCentreReference');
  }
}
